import React from 'react'
import ReactDOM from 'react-dom/client'
import {Form} from './Form'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Form />
)
